import React, { useRef } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { FiArrowUpRight } from 'react-icons/fi';
import SectionHead from '../ui/SectionHead';
import Reveal from '../ui/Reveal';
import { experience } from '../../data/profile';
import './Experience.css';

export default function Experience() {
  const listRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: listRef, offset: ['start 70%', 'end 70%'] });
  const scaleY = useSpring(scrollYProgress, { stiffness: 80, damping: 20, mass: 0.3 });

  return (
    <section className="section experience" id="experience">
      <div className="container">
        <SectionHead
          index="03"
          label="Experience"
          title={[{ text: 'Three years,' }, { text: 'four teams,', em: true }, { text: 'two countries.' }]}
          aside={<p className="small">From telecom backends in Malaysia to AI products in the UAE.</p>}
        />

        <div className="xp" ref={listRef}>
          <div className="xp__rail" aria-hidden>
            <motion.div className="xp__rail-fill" style={{ scaleY }} />
          </div>

          {experience.map((job, i) => (
            <Reveal key={job.company} className="xp__row" amount={0.2} delay={0.05}>
              <div className="xp__when">
                <span className="mono">{job.period}</span>
                <span className="xp__loc small">{job.location}</span>
                {job.current && (
                  <span className="pill pill--accent xp__current">
                    <span className="dot-live" /> Now
                  </span>
                )}
              </div>

              <div className="xp__marker" aria-hidden>
                <span className={job.current ? 'is-current' : ''} />
              </div>

              <div className="xp__what">
                <div className="xp__head">
                  <h3 className="h3">{job.role}</h3>
                  <p className="xp__company">
                    {job.href ? (
                      <a href={job.href} target="_blank" rel="noreferrer" className="link link--quiet">
                        {job.company} <FiArrowUpRight size={14} />
                      </a>
                    ) : (
                      job.company
                    )}
                  </p>
                </div>
                <p className="xp__summary">{job.summary}</p>
                <ul className="xp__points">
                  {job.points.map((p) => (
                    <li key={p} className="body">{p}</li>
                  ))}
                </ul>
                <ul className="xp__stack">
                  {job.stack.map((s) => (
                    <li key={s} className="pill">{s}</li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
